"use client";
import { Title, useComputedColorScheme } from "@mantine/core";

export default function ContentSubHeader({
  color,
  title,
  size = "2rem",
  colorDark = color,
  needsTopMargin,
}: {
  color: string;
  title: string;
  size?: string;
  colorDark?: string;
  needsTopMargin?: boolean;
}) {
  const colorScheme = useComputedColorScheme("light");
  return (
    <>
      <Title
        order={3}
        size={size}
        c={colorScheme === "dark" ? colorDark : color}
        mb={"md"}
        mt={needsTopMargin ? "5rem" : undefined}
      >
        {title}
      </Title>
    </>
  );
}
